import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { SeoHead } from 'modules/seo';
import { ChecktypeDocumentsUploadType } from 'modules/entities/modules/documents';

import { UploadDocument } from '../UploadDocument';
import { UploadInfo } from '../UploadInfo';
import { UploadDescription } from '../UploadDescription';
import { UploadPage } from '../UploadPage';

export const UploadContractPage = () => {
    const intl = useIntl();

    return (
        <UploadPage>
            <SeoHead title={intl.formatMessage({ id: 'page.uploadContract.seoTitle' })} />
            <UploadInfo
                title={<FormattedMessage id="page.uploadContract.title" />}
                description={<FormattedMessage id="page.uploadContract.description" />}
                subTitle={<FormattedMessage id="page.uploadDocument.info.title" />}
                listItems={[
                    <FormattedMessage id="page.uploadDocument.info.item-1" />,
                    <FormattedMessage id="page.uploadDocument.info.item-2" />,
                    <FormattedMessage id="page.uploadDocument.info.item-3" />,
                    <FormattedMessage id="page.uploadDocument.info.item-4" />,
                ]}
            />
            <UploadDocument type={ChecktypeDocumentsUploadType.CONTRACT} />
            <UploadDescription>
                <FormattedMessage id="page.uploadContract.infoText" />
            </UploadDescription>
        </UploadPage>
    );
};
